(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jd1-featured-collection-os"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.JD1FeaturedCollectionOSV296) return;
    window.JD1FeaturedCollectionOSV296 = true;

    const interactiveSelector = 'a, button, input, select, textarea, summary, label, [role="button"], [data-product-card-link], product-form, quick-add, .quick-add, .pf-fav-trigger';
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    const raf = (fn) => window.requestAnimationFrame(() => window.requestAnimationFrame(fn));

    const getItems = (slider) => Array.from(slider.querySelectorAll(':scope > .jd1-fc__item'));

    const getStep = (items) => {
      const first = items[0];
      const second = items[1];
      if (!first) return 1;
      if (second) {
        const step = second.offsetLeft - first.offsetLeft;
        if (step > 0) return step;
      }
      return Math.max(1, first.getBoundingClientRect().width);
    };

    const getVisibleCount = (slider, items) => {
      const step = getStep(items);
      if (!step) return 1;
      return Math.max(1, Math.round(slider.clientWidth / step));
    };

    const getGroupCount = (slider, items) => {
      if (!items.length) return 0;
      const step = getStep(items);
      const visible = getVisibleCount(slider, items);
      const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
      if (maxScroll <= 4) return 1;
      return Math.max(1, Math.ceil((items.length - visible) / visible) + 1);
    };

    const getCurrentGroup = (slider, items, groups) => {
      const visible = getVisibleCount(slider, items);
      const step = getStep(items);
      const groupStep = Math.max(1, step * visible);
      return Math.max(0, Math.min(groups - 1, Math.round(slider.scrollLeft / groupStep)));
    };

    const ensureDots = (slider) => {
      let dots = slider.nextElementSibling;
      if (!dots || !dots.classList.contains('jd1-fc__dots')) {
        dots = document.createElement('div');
        dots.className = 'jd1-fc__dots';
        dots.setAttribute('aria-label', 'Slider pagination');
        slider.insertAdjacentElement('afterend', dots);
      }
      return dots;
    };

    const updateDots = (slider) => {
      const section = slider.closest('.jd1-fc');
      if (!section || section.dataset.jd1Dots !== 'true') return;

      const items = getItems(slider);
      const dots = ensureDots(slider);
      const groups = getGroupCount(slider, items);
      const visible = getVisibleCount(slider, items);

      if (groups <= 1) {
        dots.hidden = true;
        dots.innerHTML = '';
        dots.dataset.jd1Groups = '0';
        return;
      }

      dots.hidden = false;

      if (dots.dataset.jd1Groups !== String(groups)) {
        dots.innerHTML = '';
        dots.dataset.jd1Groups = String(groups);

        for (let index = 0; index < groups; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'jd1-fc__dot';
          dot.setAttribute('aria-label', `Ir al grupo ${index + 1}`);
          dot.addEventListener('click', () => {
            const targetIndex = Math.min(index * visible, items.length - 1);
            const target = items[targetIndex];
            if (!target) return;
            slider.scrollTo({ left: target.offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
          });
          dots.appendChild(dot);
        }
      }

      const current = getCurrentGroup(slider, items, groups);
      dots.querySelectorAll('.jd1-fc__dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === current);
        dot.setAttribute('aria-current', index === current ? 'true' : 'false');
      });
    };

    const bindMouseDrag = (slider) => {
      if (slider.dataset.jd1DragBound) return;
      slider.dataset.jd1DragBound = 'true';

      let isDown = false;
      let startX = 0;
      let startLeft = 0;
      let dragged = false;

      slider.addEventListener('pointerdown', (event) => {
        if (!finePointer.matches) return;
        if (event.button !== undefined && event.button !== 0) return;
        if (event.target.closest(interactiveSelector)) return;

        isDown = true;
        dragged = false;
        startX = event.clientX;
        startLeft = slider.scrollLeft;
        slider.classList.add('is-dragging');
        slider.setPointerCapture?.(event.pointerId);
      });

      slider.addEventListener('pointermove', (event) => {
        if (!isDown) return;
        const dx = event.clientX - startX;
        if (Math.abs(dx) > 8) dragged = true;
        if (dragged) slider.scrollLeft = startLeft - dx;
      });

      const endDrag = (event) => {
        if (!isDown) return;
        isDown = false;
        slider.classList.remove('is-dragging');
        slider.releasePointerCapture?.(event.pointerId);
      };

      slider.addEventListener('pointerup', endDrag);
      slider.addEventListener('pointercancel', endDrag);
      slider.addEventListener('pointerleave', endDrag);

      slider.addEventListener('click', (event) => {
        if (!dragged) return;
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }, true);
    };

    const bindSlider = (slider) => {
      if (!slider.classList.contains('jd1-fc__items--slider')) return;
      if (!slider.querySelector(':scope > .jd1-fc__item')) return;

      bindMouseDrag(slider);

      if (!slider.dataset.jd1ScrollBound) {
        slider.dataset.jd1ScrollBound = 'true';
        let ticking = false;
        slider.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            updateDots(slider);
          });
        }, { passive: true });
      }

      updateDots(slider);
    };

    const init = (root = document, resetActive = false) => {
      const sliders = root.querySelectorAll('.jd1-fc__items--slider');

      sliders.forEach((slider) => {
        bindSlider(slider);

        if (resetActive && slider.offsetParent !== null) {
          slider.scrollTo({ left: 0, behavior: 'auto' });
        }

        raf(() => updateDots(slider));
      });
    };

    const initActivePanel = (input) => {
      const section = input.closest('.jd1-fc');
      if (!section) return;
      raf(() => {
        section.querySelectorAll('.jd1-fc__items--slider').forEach((slider) => {
          if (slider.offsetParent !== null) {
            slider.scrollTo({ left: 0, behavior: 'auto' });
            updateDots(slider);
          }
        });
      });
    };

    document.addEventListener('DOMContentLoaded', () => init(document, false));
    document.addEventListener('shopify:section:load', (event) => init(event.target, false));
    document.addEventListener('shopify:block:select', (event) => init(event.target, false));

    document.addEventListener('change', (event) => {
      if (event.target.matches('.jd1-fc__tab-input')) initActivePanel(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => init(document, false), 140);
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd1-recos-os"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.JD1RecosOSV16) return;
    window.JD1RecosOSV16 = true;

    const init = (root = document) => {
      root.querySelectorAll('[data-jd1-recos-os]').forEach((section) => {
        const track = section.querySelector('[data-jd1-recos-track]');
        const dots = section.querySelector('[data-jd1-recos-dots]');
        const items = track ? Array.from(track.querySelectorAll('[data-jd1-recos-item]')) : [];

        if (!track || !dots || !items.length) return;

        const build = () => {
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const isScrollable = getComputedStyle(track).overflowX !== 'visible' && track.scrollWidth > track.clientWidth + 4;

          if (!isScrollable) {
            dots.hidden = true;
            dots.innerHTML = '';
            return;
          }

          const first = items[0];
          const second = items[1];
          const step = second ? second.offsetLeft - first.offsetLeft : first.getBoundingClientRect().width;
          const groups = Math.max(1, Math.ceil((track.scrollWidth - track.clientWidth) / Math.max(1, step)) + 1);

          dots.hidden = groups <= 1;
          if (groups <= 1) {
            dots.innerHTML = '';
            return;
          }

          if (dots.children.length !== groups) {
            dots.innerHTML = '';
            for (let index = 0; index < groups; index += 1) {
              const button = document.createElement('button');
              button.type = 'button';
              button.className = 'jd1-recos-os__dot';
              button.setAttribute('aria-label', `Go to recommendation group ${index + 1}`);
              button.addEventListener('click', () => {
                track.scrollTo({ left: index * step, behavior: 'smooth' });
              });
              dots.appendChild(button);
            }
          }

          const update = () => {
            const current = Math.round(track.scrollLeft / Math.max(1, step));
            dots.querySelectorAll('.jd1-recos-os__dot').forEach((dot, index) => {
              dot.classList.toggle('is-active', index === current);
            });
          };

          update();
          track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
        };

        build();
        window.addEventListener('resize', build, { passive: true });
      });
    };

    document.addEventListener('DOMContentLoaded', () => init());
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd1-shop-the-gram"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-jd1-stg]');

    roots.forEach((root) => {
      if (root.dataset.stgBound === 'true') return;
      root.dataset.stgBound = 'true';

      const modal = root.querySelector('[data-stg-modal]');
      const items = Array.from(root.querySelectorAll('[data-stg-modal-item]'));
      const galleryVideos = Array.from(root.querySelectorAll('.jd1-stg__post video'));
      const modalVideos = Array.from(root.querySelectorAll('[data-stg-modal-item] video'));
      const allVideos = galleryVideos.concat(modalVideos);
      const videoVisibility = new Map(galleryVideos.map((video) => [video, 0]));
      let current = 0;

      const pauseVideo = (video, reset = false) => {
        if (!video) return;
        video.pause();
        if (reset) {
          try {
            video.currentTime = 0;
          } catch (error) {
            // El video todavía puede no tener metadatos cargados.
          }
        }
      };

      const pauseVideos = (videos, reset = false) => {
        videos.forEach((video) => pauseVideo(video, reset));
      };

      const playOnly = (video) => {
        if (!video) return;

        allVideos.forEach((otherVideo) => {
          if (otherVideo !== video) pauseVideo(otherVideo);
        });

        video.muted = true;
        video.playsInline = true;
        const playRequest = video.play();
        if (playRequest && typeof playRequest.catch === 'function') {
          playRequest.catch(() => {
            // El navegador puede bloquear autoplay hasta la primera interacción.
          });
        }
      };

      const playCurrentModalVideo = () => {
        if (!modal || modal.hidden) return;
        const activeItem = items[current];
        const activeVideo = activeItem ? activeItem.querySelector('video') : null;

        pauseVideos(galleryVideos);
        modalVideos.forEach((video) => {
          if (video !== activeVideo) pauseVideo(video, true);
        });
        playOnly(activeVideo);
      };

      const playVisibleGalleryVideo = () => {
        if ((modal && !modal.hidden) || document.hidden) return;

        let visibleVideo = null;
        let bestRatio = 0;
        videoVisibility.forEach((ratio, video) => {
          if (ratio > bestRatio) {
            visibleVideo = video;
            bestRatio = ratio;
          }
        });

        pauseVideos(modalVideos, true);
        if (visibleVideo && bestRatio >= 0.25) {
          playOnly(visibleVideo);
        } else {
          pauseVideos(galleryVideos);
        }
      };

      // Garantía adicional: incluso si el usuario pulsa Play manualmente,
      // cualquier otro video de esta sección se pausa de inmediato.
      root.addEventListener('play', (event) => {
        const playedVideo = event.target;
        if (!playedVideo || playedVideo.tagName !== 'VIDEO') return;
        allVideos.forEach((video) => {
          if (video !== playedVideo) pauseVideo(video);
        });
      }, true);

      if ('IntersectionObserver' in window && galleryVideos.length) {
        const videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            videoVisibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
          });
          playVisibleGalleryVideo();
        }, {
          threshold: [0, 0.25, 0.5, 0.75, 1]
        });

        galleryVideos.forEach((video) => videoObserver.observe(video));
      } else if (galleryVideos.length) {
        videoVisibility.set(galleryVideos[0], 1);
        playVisibleGalleryVideo();
      }

      const setActive = (index) => {
        if (!items.length) return;
        current = (index + items.length) % items.length;
        items.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === current);
        });
        if (modal && !modal.hidden) {
          requestAnimationFrame(playCurrentModalVideo);
        }
      };

      const openModal = (index) => {
        if (!modal || !items.length) return;
        pauseVideos(galleryVideos);
        modal.hidden = false;
        document.documentElement.classList.add('jd1-stg-modal-open');
        setActive(index);
      };

      const closeModal = () => {
        if (!modal) return;
        pauseVideos(modalVideos, true);
        modal.hidden = true;
        document.documentElement.classList.remove('jd1-stg-modal-open');
        root.querySelectorAll('.jd1-stg__product-pop.is-active').forEach((pop) => pop.classList.remove('is-active'));
        requestAnimationFrame(playVisibleGalleryVideo);
      };

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          pauseVideos(allVideos);
        } else if (modal && !modal.hidden) {
          playCurrentModalVideo();
        } else {
          playVisibleGalleryVideo();
        }
      });

      const toggleHotspot = (button) => {
        const key = button.getAttribute('data-stg-hotspot');
        const scope = button.closest('.jd1-stg__post, .jd1-stg__modal-media') || root;
        scope.querySelectorAll('.jd1-stg__product-pop').forEach((pop) => {
          pop.classList.toggle('is-active', pop.getAttribute('data-stg-product-panel') === key);
        });
        const activeItem = button.closest('.jd1-stg__modal-item');
        if (activeItem) {
          activeItem.querySelectorAll('.jd1-stg__side-product').forEach((card) => {
            card.classList.toggle('is-active', card.getAttribute('data-stg-product-card') === key);
          });
        }
      };

      root.addEventListener('click', (event) => {
        const hotspot = event.target.closest('[data-stg-hotspot]');
        if (hotspot && root.contains(hotspot)) {
          event.preventDefault();
          event.stopPropagation();
          toggleHotspot(hotspot);
          return;
        }

        if (event.target.closest('a')) return;

        if (event.target.closest('[data-stg-close]')) {
          closeModal();
          return;
        }

        if (event.target.closest('[data-stg-prev]')) {
          setActive(current - 1);
          return;
        }

        if (event.target.closest('[data-stg-next]')) {
          setActive(current + 1);
          return;
        }

        if (event.target === modal) {
          closeModal();
          return;
        }

        const opener = event.target.closest('[data-stg-open]');
        if (opener && root.contains(opener)) {
          openModal(Number(opener.dataset.stgIndex || 0));
        }
      });

      document.addEventListener('keydown', (event) => {
        if (!modal || modal.hidden) return;
        if (event.key === 'Escape') closeModal();
        if (event.key === 'ArrowLeft') setActive(current - 1);
        if (event.key === 'ArrowRight') setActive(current + 1);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jd1-stories"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('jd1-native-stories')) return;

  class JD1Stories extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.triggers = [...this.querySelectorAll('[data-story-trigger]')];
      this.slides = [...this.querySelectorAll('[data-story-slide]')];
      this.progress = [...this.querySelectorAll('[data-progress]')];
      this.viewer = this.querySelector('.jd1-stories__viewer');
      this.dialog = this.querySelector('.jd1-stories__dialog');
      this.rail = this.querySelector('.jd1-stories__rail');
      this.title = this.querySelector('.jd1-stories__viewer-title');
      this.avatar = this.querySelector('.jd1-stories__viewer-avatar-wrap');
      this.nextTitle = this.querySelector('.jd1-stories__next-title');
      this.pauseButton = this.querySelector('[data-story-pause]');
      this.soundButton = this.querySelector('[data-story-sound]');
      this.railPrevious = this.querySelector('.jd1-stories__rail-arrow--prev');
      this.railNext = this.querySelector('.jd1-stories__rail-arrow--next');

      this.index = 0;
      this.paused = false;
      this.muted = this.dataset.startMuted !== 'false';
      this.frame = null;
      this.imageStart = 0;
      this.imageElapsed = 0;
      this.lastFocus = null;
      this.pointerStart = null;
      this.activeVideo = null;
      this.playAttempt = 0;
      this.storageKey = `jd1-stories-seen-${this.dataset.sectionId}`;
      this.seen = this.readSeen();

      this.paintSeen();
      this.bind();
      this.updateRailButtons();
      this.classList.toggle('is-muted', this.muted);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      document.removeEventListener('keydown', this.onKeydown);
    }

    bind() {
      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => this.open(index));
      });

      this.querySelectorAll('[data-story-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });
      this.querySelectorAll('[data-story-next]').forEach((button) => {
        button.addEventListener('click', () => this.next());
      });
      this.querySelectorAll('[data-story-prev]').forEach((button) => {
        button.addEventListener('click', () => this.previous());
      });

      this.pauseButton?.addEventListener('click', () => this.togglePause());
      this.soundButton?.addEventListener('click', () => this.toggleSound());
      this.querySelectorAll('[data-story-manual-play]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          this.resumeVideoFromGesture(button);
        });
      });

      this.querySelectorAll('[data-story-product-toggle]').forEach((button) => {
        button.addEventListener('click', () => this.toggleProduct(button));
      });
      this.querySelectorAll('[data-story-product-ui]').forEach((element) => {
        element.addEventListener('pointerdown', (event) => event.stopPropagation());
        element.addEventListener('pointerup', (event) => event.stopPropagation());
      });

      this.railPrevious?.addEventListener('click', () => this.scrollRail(-1));
      this.railNext?.addEventListener('click', () => this.scrollRail(1));
      this.rail?.addEventListener('scroll', () => this.updateRailButtons(), { passive: true });

      this.onKeydown = (event) => {
        if (!this.isViewerOpen()) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowRight') this.next();
        if (event.key === 'ArrowLeft') this.previous();
        if (event.key === ' ') {
          event.preventDefault();
          this.togglePause();
        }
      };
      document.addEventListener('keydown', this.onKeydown);

      this.viewer?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      this.dialog?.addEventListener('pointerdown', (event) => {
        this.pointerStart = { x: event.clientX, y: event.clientY };
      });
      this.dialog?.addEventListener('pointerup', (event) => {
        if (!this.pointerStart) return;
        const dx = event.clientX - this.pointerStart.x;
        const dy = event.clientY - this.pointerStart.y;
        this.pointerStart = null;
        if (Math.abs(dx) < 55 || Math.abs(dx) < Math.abs(dy)) return;
        dx < 0 ? this.next() : this.previous();
      });

      document.addEventListener('shopify:section:unload', (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.close(false);
      });
    }

    open(index) {
      if (!this.viewer || !this.slides.length) return;
      this.lastFocus = document.activeElement;

      if (typeof this.viewer.showModal === 'function') {
        if (!this.viewer.open) this.viewer.showModal();
      } else {
        this.viewer.hidden = false;
      }

      this.viewer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('jd1-stories-lock');
      this.show(index);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const video = this.slides[this.index]?.querySelector('video');
          if (video && this.dataset.autoplay !== 'false' && video.paused) {
            this.playVideo(video);
          }
        });
      });
      this.viewer.querySelector('[data-story-close]:not(.jd1-stories__backdrop)')?.focus();
    }

    close(restoreFocus = true) {
      if (!this.viewer || !this.isViewerOpen()) return;
      cancelAnimationFrame(this.frame);
      this.stopAllVideos();

      if (typeof this.viewer.close === 'function' && this.viewer.open) {
        this.viewer.close();
      } else {
        this.viewer.hidden = true;
      }

      this.viewer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('jd1-stories-lock');
      if (restoreFocus && this.lastFocus instanceof HTMLElement) this.lastFocus.focus();
    }

    isViewerOpen() {
      if (!this.viewer) return false;
      if (typeof this.viewer.open === 'boolean') return this.viewer.open;
      return !this.viewer.hidden;
    }

    show(index) {
      cancelAnimationFrame(this.frame);
      this.stopAllVideos();
      this.paused = false;
      this.classList.remove('is-paused');
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));

      this.slides.forEach((slide, slideIndex) => {
        slide.hidden = slideIndex !== this.index;
        const manualPlay = slide.querySelector('[data-story-manual-play]');
        if (manualPlay) manualPlay.hidden = true;
      });
      this.progress.forEach((track, trackIndex) => {
        const value = track.querySelector('.jd1-stories__progress-value');
        value.style.transform = `scaleX(${trackIndex < this.index ? 1 : 0})`;
      });

      const slide = this.slides[this.index];
      this.title.textContent = slide.dataset.storyTitle || '';
      const productOpen = slide.dataset.storyProductOpen !== 'false';
      slide.classList.toggle('is-product-collapsed', !productOpen);
      slide.querySelector('[data-story-product-toggle]')?.setAttribute('aria-expanded', String(productOpen));
      slide.querySelector('[data-story-product-card]')?.setAttribute('aria-hidden', String(!productOpen));
      const template = slide.querySelector('[data-story-avatar]');
      this.avatar.replaceChildren();
      if (template?.content) this.avatar.append(template.content.cloneNode(true));
      this.nextTitle.textContent = this.slides[this.nextIndex()]?.dataset.storyTitle || '';

      this.seen.add(String(this.index));
      this.writeSeen();
      this.paintSeen();
      this.startCurrent();
    }

    startCurrent() {
      const slide = this.slides[this.index];
      const video = slide.querySelector('video');
      const value = this.progress[this.index]?.querySelector('.jd1-stories__progress-value');
      if (!value) return;
      const shouldAutoplay = this.dataset.autoplay !== 'false';

      if (video) {
        video.preload = 'auto';
        this.activeVideo = video;
        this.setManualPlay(video, false);
        const playAttempt = ++this.playAttempt;
        if (shouldAutoplay) {
          this.muted = true;
          this.classList.add('is-muted');
        }
        this.applyMutedState(video);
        this.prepareVideoSources(video);
        video.autoplay = shouldAutoplay;
        if (shouldAutoplay) {
          video.setAttribute('autoplay', '');
        } else {
          video.removeAttribute('autoplay');
        }

        try {
          video.load();
        } catch (_) {}
        try {
          video.currentTime = 0;
        } catch (_) {}
        this.animateVideo(video, value);

        if (shouldAutoplay) {
          this.paused = false;
          this.classList.remove('is-paused');
          this.playVideo(video, playAttempt);
          this.queueVideoPlay(video, playAttempt);
        } else {
          this.paused = true;
          this.classList.add('is-paused');
          this.setManualPlay(video, true);
        }
      } else {
        if (!shouldAutoplay) {
          this.paused = true;
          this.classList.add('is-paused');
        }
        this.imageElapsed = 0;
        this.imageStart = performance.now();
        this.animateImage(value);
      }
    }

    queueVideoPlay(video, playAttempt) {
      const requestPlay = () => {
        this.playVideo(video, playAttempt);
      };

      if (video.readyState >= 2) {
        requestPlay();
        return;
      }

      video.addEventListener('loadeddata', requestPlay, { once: true });
      video.addEventListener('canplay', requestPlay, { once: true });
      requestPlay();
      window.setTimeout(requestPlay, 140);
      window.setTimeout(requestPlay, 420);
    }

    prepareVideoSources(video) {
      video.querySelectorAll('source[data-src]').forEach((source) => {
        if (!source.getAttribute('src')) {
          source.setAttribute('src', source.dataset.src);
        }
      });
    }

    applyMutedState(video) {
      video.muted = this.muted;
      video.defaultMuted = this.muted;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      if (this.muted) {
        video.setAttribute('muted', '');
      } else {
        video.removeAttribute('muted');
      }
    }

    async playVideo(video, playAttempt = this.playAttempt) {
      if (!this.isCurrentVideo(video, playAttempt)) return;
      this.applyMutedState(video);

      try {
        await video.play();
      } catch (_) {
        if (!this.isCurrentVideo(video, playAttempt)) return;
        this.muted = true;
        this.classList.add('is-muted');
        this.applyMutedState(video);
        try {
          await video.play();
        } catch (_) {
          if (this.isCurrentVideo(video, playAttempt)) {
            this.paused = true;
            this.classList.add('is-paused');
            this.setManualPlay(video, true);
          }
          return;
        }
      }

      if (!this.isCurrentVideo(video, playAttempt)) {
        video.pause();
        return;
      }

      this.paused = false;
      this.classList.remove('is-paused');
      this.setManualPlay(video, false);
    }

    resumeVideoFromGesture(button) {
      const slide = button.closest('[data-story-slide]');
      const video = slide?.querySelector('video');
      if (!video || slide !== this.slides[this.index]) return;

      this.paused = false;
      this.classList.remove('is-paused');
      this.activeVideo = video;
      const playAttempt = ++this.playAttempt;
      video.preload = 'auto';
      this.prepareVideoSources(video);
      this.applyMutedState(video);
      this.setManualPlay(video, false);
      this.playVideo(video, playAttempt);
    }

    setManualPlay(video, visible) {
      const button = video.closest('[data-story-slide]')?.querySelector('[data-story-manual-play]');
      if (button) button.hidden = !visible;
    }

    isCurrentVideo(video, playAttempt = this.playAttempt) {
      const currentVideo = this.slides[this.index]?.querySelector('video');
      return playAttempt === this.playAttempt
        && video === currentVideo
        && video === this.activeVideo
        && this.isViewerOpen()
        && !this.slides[this.index]?.hidden
        && !this.paused;
    }

    animateVideo(video, value) {
      const tick = () => {
        if (this.isViewerOpen() && !video.paused && Number.isFinite(video.duration) && video.duration > 0) {
          value.style.transform = `scaleX(${Math.min(video.currentTime / video.duration, 1)})`;
        }
        if (video.ended) {
          this.next(true);
          return;
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    animateImage(value) {
      const duration = Math.max(3, Number(this.dataset.imageDuration) || 6) * 1000;
      const tick = (now) => {
        if (!this.paused) {
          const elapsed = this.imageElapsed + (now - this.imageStart);
          value.style.transform = `scaleX(${Math.min(elapsed / duration, 1)})`;
          if (elapsed >= duration) {
            this.next(true);
            return;
          }
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    next(automatic = false) {
      if (this.index < this.slides.length - 1) {
        this.show(this.index + 1);
      } else if (this.dataset.loop === 'true') {
        this.show(0);
      } else if (automatic) {
        this.close();
      }
    }

    previous() {
      if (this.index > 0) {
        this.show(this.index - 1);
      } else if (this.dataset.loop === 'true') {
        this.show(this.slides.length - 1);
      }
    }

    nextIndex() {
      if (this.index < this.slides.length - 1) return this.index + 1;
      return this.dataset.loop === 'true' ? 0 : this.index;
    }

    togglePause() {
      this.paused = !this.paused;
      this.classList.toggle('is-paused', this.paused);
      const video = this.slides[this.index]?.querySelector('video');
      if (video) {
        this.paused ? video.pause() : this.playVideo(video);
      } else if (this.paused) {
        this.imageElapsed += performance.now() - this.imageStart;
      } else {
        this.imageStart = performance.now();
      }
    }

    toggleSound() {
      this.muted = !this.muted;
      this.classList.toggle('is-muted', this.muted);
      const video = this.slides[this.index]?.querySelector('video');
      if (video) this.applyMutedState(video);
    }

    toggleProduct(button) {
      const slide = button.closest('[data-story-slide]');
      const card = slide?.querySelector('[data-story-product-card]');
      if (!slide || !card) return;
      const willOpen = slide.classList.contains('is-product-collapsed');
      slide.classList.toggle('is-product-collapsed', !willOpen);
      button.setAttribute('aria-expanded', String(willOpen));
      card.setAttribute('aria-hidden', String(!willOpen));
    }

    stopAllVideos() {
      this.playAttempt += 1;
      this.activeVideo = null;
      this.slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (!video) return;
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.pause();
        this.setManualPlay(video, false);
        try {
          video.currentTime = 0;
        } catch (_) {}
      });
    }

    scrollRail(direction) {
      const amount = (this.rail.clientWidth * .78) * direction;
      this.rail.scrollBy({ left: amount, behavior: 'smooth' });
    }

    updateRailButtons() {
      if (!this.rail) return;
      const atStart = this.rail.scrollLeft <= 2;
      const atEnd = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2;
      if (this.railPrevious) this.railPrevious.disabled = atStart;
      if (this.railNext) this.railNext.disabled = atEnd;
    }

    readSeen() {
      try {
        return new Set(JSON.parse(localStorage.getItem(this.storageKey) || '[]'));
      } catch (_) {
        return new Set();
      }
    }

    writeSeen() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify([...this.seen]));
      } catch (_) {}
    }

    paintSeen() {
      this.triggers.forEach((trigger, index) => {
        const isSeen = this.seen.has(String(index));
        trigger.classList.toggle('is-seen', isSeen);
        if (isSeen) trigger.dataset.seen = this.dataset.seenLabel || 'Vista';
      });
    }
  }

  customElements.define('jd1-native-stories', JD1Stories);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-announcement-rotator')) {
    customElements.define('pf-announcement-rotator', class extends HTMLElement {
      connectedCallback() {
        this.messages = Array.from(this.querySelectorAll('[data-pf-message]'));
        if (!this.messages.length) return;

        this.media = window.matchMedia('(min-width: 750px)');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.interval = Math.max(2500, Number(this.dataset.interval) || 5000);
        this.mode = this.dataset.mode || 'fade';
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        this.currentIndex = 0;

        this.onViewportChange = () => this.refresh(true);
        this.onEnter = () => this.pause();
        this.onLeave = () => this.start();
        this.onBlockSelect = (event) => {
          const selected = this.messages.find((message) => message.dataset.blockId === event.detail.blockId);
          if (!selected) return;
          const eligible = this.getEligibleMessages();
          const selectedIndex = eligible.indexOf(selected);
          if (selectedIndex < 0) return;
          this.pause();
          this.currentIndex = selectedIndex;
          this.showCurrent(eligible);
        };
        this.onBlockDeselect = () => this.start();

        if (this.media.addEventListener) this.media.addEventListener('change', this.onViewportChange);
        else this.media.addListener(this.onViewportChange);

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', this.onEnter);
          this.addEventListener('mouseleave', this.onLeave);
          this.addEventListener('focusin', this.onEnter);
          this.addEventListener('focusout', this.onLeave);
        }

        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.refresh(true);
        this.dataset.ready = 'true';
      }

      disconnectedCallback() {
        this.pause();
        if (this.media) {
          if (this.media.removeEventListener) this.media.removeEventListener('change', this.onViewportChange);
          else this.media.removeListener(this.onViewportChange);
        }
        this.removeEventListener('mouseenter', this.onEnter);
        this.removeEventListener('mouseleave', this.onLeave);
        this.removeEventListener('focusin', this.onEnter);
        this.removeEventListener('focusout', this.onLeave);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      getEligibleMessages() {
        const key = this.media.matches ? 'showDesktop' : 'showMobile';
        return this.messages.filter((message) => message.dataset[key] !== 'false');
      }

      refresh(resetIndex = false) {
        this.pause();
        const eligible = this.getEligibleMessages();
        if (!eligible.length) {
          this.messages.forEach((message) => this.setMessageState(message, false));
          return;
        }
        if (resetIndex || this.currentIndex >= eligible.length) this.currentIndex = 0;
        this.showCurrent(eligible);
        this.start();
      }

      showCurrent(eligible = this.getEligibleMessages()) {
        const active = eligible[this.currentIndex];
        this.messages.forEach((message) => this.setMessageState(message, message === active));
      }

      setMessageState(message, active) {
        message.classList.toggle('is-active', active);
        message.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (message.matches('a')) message.tabIndex = active ? 0 : -1;
      }

      start() {
        this.pause();
        const eligible = this.getEligibleMessages();
        if (this.mode !== 'fade' || this.reduceMotion.matches || eligible.length < 2) return;
        this.timer = window.setInterval(() => {
          const currentEligible = this.getEligibleMessages();
          if (currentEligible.length < 2) return;
          this.currentIndex = (this.currentIndex + 1) % currentEligible.length;
          this.showCurrent(currentEligible);
        }, this.interval);
      }

      pause() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class PfHeroSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-pf-slide]'));
      this.prevButton = this.querySelector('[data-pf-prev]');
      this.nextButton = this.querySelector('[data-pf-next]');
      this.dotsContainer = this.querySelector('[data-pf-dots]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = Number(this.dataset.speed || 5000);
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.timer = null;

      this.renderDots();
      this.goTo(this.index, false);
      this.bindEvents();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    bindEvents() {
      this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      document.addEventListener('shopify:block:select', (event) => {
        const slide = event.target?.closest?.('[data-pf-slide]');
        if (!slide || !this.contains(slide)) return;
        const nextIndex = this.slides.indexOf(slide);
        if (nextIndex >= 0) {
          this.stop();
          this.goTo(nextIndex);
        }
      });
    }

    renderDots() {
      if (!this.dotsContainer || this.slides.length <= 1) return;
      this.dotsContainer.innerHTML = '';
      this.dots = this.slides.map((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pf-hero__dot';
        dot.setAttribute('aria-label', `Ir al slide ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        this.dotsContainer.append(dot);
        return dot;
      });
    }

    goTo(nextIndex, shouldRestart = true) {
      if (!this.slides.length) return;
      const total = this.slides.length;
      this.index = ((nextIndex % total) + total) % total;

      const activeSlide = this.slides[this.index];
      if (activeSlide?.dataset?.pfBannerRatioD) {
        this.style.setProperty('--pf-active-banner-ratio-d', activeSlide.dataset.pfBannerRatioD);
      }
      if (activeSlide?.dataset?.pfBannerRatioM) {
        this.style.setProperty('--pf-active-banner-ratio-m', activeSlide.dataset.pfBannerRatioM);
      }

      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots?.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === this.index);
        dot.setAttribute('aria-current', index === this.index ? 'true' : 'false');
      });

      if (shouldRestart) {
        this.stop();
        this.start();
      }
    }

    start() {
      if (!this.autoplay || this.slides.length <= 1) return;
      this.stop();
      this.timer = window.setInterval(() => this.goTo(this.index + 1, false), this.speed);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('pf-hero-slider')) {
    customElements.define('pf-hero-slider', PfHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.JD1ProductRecommendationsCarouselV138) return;
    window.JD1ProductRecommendationsCarouselV138 = true;

    const registry = new WeakMap();
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const toBool = (value) => value === true || value === 'true';

    const getConfig = (carousel) => {
      const mobile = mobileQuery.matches;
      const cols = Math.max(
        1,
        parseFloat(mobile ? carousel.dataset.mobileCols : carousel.dataset.desktopCols) || (mobile ? 1.5 : 4)
      );
      const dots = toBool(mobile ? carousel.dataset.mobileDots : carousel.dataset.desktopDots);
      return { mobile, cols, dots };
    };

    const setupCarousel = (carousel) => {
      const track = carousel.querySelector('[data-jd1-pr-track]');
      const dotsWrap = carousel.querySelector('[data-jd1-pr-dots]');
      if (!track || !dotsWrap) return;

      const slides = Array.from(carousel.querySelectorAll('[data-jd1-pr-slide]'));
      if (!slides.length) return;

      let state = registry.get(carousel);
      if (!state) {
        state = { active: 0, groups: 0, cols: 0, ticking: false };
        registry.set(carousel, state);

        const update = () => {
          state.ticking = false;
          const { cols, dots } = getConfig(carousel);
          const isFractional = cols % 1 !== 0;
          const maxGroups = isFractional
            ? Math.max(1, Math.ceil(slides.length - cols + 1))
            : Math.max(1, Math.ceil(slides.length / cols));
          if (!dots || maxGroups <= 1) {
            dotsWrap.hidden = true;
            return;
          }

          dotsWrap.hidden = false;
          const first = slides[0];
          const second = slides[1];
          const step = second ? second.offsetLeft - first.offsetLeft : first.getBoundingClientRect().width;
          const groupStep = Math.max(1, step * (cols % 1 !== 0 ? 1 : cols));
          const current = Math.max(0, Math.min(maxGroups - 1, Math.round(track.scrollLeft / groupStep)));

          dotsWrap.querySelectorAll('[data-jd1-pr-dot]').forEach((dot, index) => {
            dot.classList.toggle('is-active', index === current);
            dot.setAttribute('aria-current', index === current ? 'true' : 'false');
          });
          state.active = current;
        };

        const buildDots = () => {
          const { cols, dots } = getConfig(carousel);
          const isFractional = cols % 1 !== 0;
          const groups = isFractional
            ? Math.max(1, Math.ceil(slides.length - cols + 1))
            : Math.max(1, Math.ceil(slides.length / cols));
          if (state.groups === groups && state.cols === cols && dotsWrap.children.length === groups) {
            update();
            return;
          }

          dotsWrap.innerHTML = '';
          state.groups = groups;
          state.cols = cols;

          for (let index = 0; index < groups; index += 1) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'jd1-pr-carousel__dot';
            button.setAttribute('data-jd1-pr-dot', '');
            button.setAttribute('aria-label', `Go to product group ${index + 1}`);
            button.addEventListener('click', () => {
              const targetIndex = cols % 1 !== 0 ? index : Math.min(index * cols, slides.length - 1);
              const target = slides[targetIndex];
              if (!target) return;
              track.scrollTo({ left: target.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
            });
            dotsWrap.appendChild(button);
          }
          update();
        };

        track.addEventListener('scroll', () => {
          if (state.ticking) return;
          state.ticking = true;
          window.requestAnimationFrame(update);
        }, { passive: true });

        window.addEventListener('resize', buildDots, { passive: true });
        mobileQuery.addEventListener?.('change', buildDots);
        carousel.__jd1BuildDots = buildDots;
      }

      carousel.__jd1BuildDots?.();
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-jd1-pr-carousel]').forEach(setupCarousel);
    };

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(() => init());
    });

    document.addEventListener('DOMContentLoaded', () => init());
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    init();
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
